import React, { useState, useEffect } from "react";
import {
  IoChatboxEllipsesOutline,
  IoHeartOutline,
  IoHeart,
} from "react-icons/io5";

import { FiPhoneCall } from "react-icons/fi";
import { Link } from "react-router-dom";
// import Cookies from "universal-cookie";
// import { IoSettingsOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";

export const UserProfile = () => {
  // const cookies = new Cookies(null, { path: "/" });
  const { userId } = useParams();

  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId1 = userId;
  const [posts, setPosts] = useState([]);
  const [fill, setFill] = useState([]);

  const fetchUserData = async () => {
    try {
      const userId = userId1; // Replace with the actual user ID

      const response = await fetch(
        `http://localhost:3001/user/${userId}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch user data.");
      }

      const data = await response.json();
      setUserData(data.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setError(error.message);
      setLoading(false);
    }
  };
  const fetchPosts = async () => {
    try {
      const userId = userId1; // Replace with the actual user ID
      const response = await fetch(`http://localhost:3001/posts/${userId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch posts");
      }
      const data = await response.json();
      setPosts(data.data);
      // console.log(data.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchUserData();
    fetchPosts();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleheart = (index) => {
    const updateFill = [...fill];
    updateFill[index] = !updateFill[index];
    setFill(updateFill);
  };
  
  const handleGoBack = () => {
    // Go back one step
    window.history.back();
  };
  return (
    <section>
      <div className="h-[270px] flex-col space-y-4 bg-primary-100">
        <div className="flex justify-between items-center ">
        <div
          onClick={handleGoBack}
          className="backIcon  flex-[1] p-2 h-full hover:cursor-pointer center text-white text-3xl pt-4"
        >
            <IoIosArrowRoundBack />
         
        </div>
          <h1 className="flex-1 pt-4 text-3xl text-white font-kurdish_043 text-center">
            Profile
          </h1>
          <h1 className="flex-1 pt-4 text-3xl text-white center ">
          
          </h1>
        </div>
        {/* پڕۆفایل */}
        <div className="flex justify-center">
          <div className="avatar flex-col justify-center items-center ">
            <div className="w-24 rounded-full ">
              {userData && (
                <img
                  src={userData.profileUrl || "https://via.placeholder.com/150"}
                  alt=""
                />
              )}
            </div>
            <p className="pt-2 font-thin text-white font-kurdish_041">
              {userData && userData.name}
            </p>
          </div>
        </div>
        <div className="flex gap-4 justify-center">
          <IoChatboxEllipsesOutline
            className="border-non rounded-full p-[6px] w-12 h-11 bg-[#4d3db0]"
            size={40}
            color="white"
          />
          <IoHeartOutline
            className="border-non rounded-full p-1 w-12 h-11 bg-[#4d3db0] "
            size={40}
            color="white"
          />
          <Link to={`tel:0964${userData.phoneNumber}`}>
            <FiPhoneCall
              className="border-non rounded-full p-2 w-[50px] h-11 w- bg-[#4d3db0]"
              size={40}
              color="white"
            />
          </Link>
        </div>
      </div>
      {/* بەشی بڵاوکراواکان */}
      {/* <Blawkrawakan/> */}
      <div className="posts w-full h-full p-8">
        {posts.map((post, index) => (
          <Link
            to={`/post/${post.postId}`}
            className="carousel-item"
            key={index}
          >
            <div className="card relative shadow-lg mb-6 pb-2">
              <div className="image relative">
                {/* <img
                  src={Crown}
                  className="absolute left-3 h-8 w-8 bg-[#e1b600] rounded-b-lg"
                  alt="h"
                /> */}
                <p className="text-sm flex font-bold text-white font-kurdish_041 px-2 py-1 center text-center absolute top-0 bg-primary-100 right-0 rounded-tr-lg rounded-bl-lg ">
                  {post.address}
                  <CiLocationOn className="text-md" />
                </p>
                <img
                  src={post.images[0]} // Assuming the first image is the main image
                  className="w-full aspect-square rounded-tr-lg rounded-tl-lg"
                  alt={post.title}
                />
              </div>
              <div className="title center p-2">
                <p className="center font-kurdish_043 text-2xl">
                  {" "}
                  {post.title}{" "}
                </p>
              </div>
              <div className="flex p-2">
                <div className="flex-[1] flex flex-col text-center bg-primary-100 text-white rounded-md">
                  <h6 className="font-semibold font-kurdish_042 px-4 py-2 center gap-2">
                    <span>{post.priceType}</span>
                    <span>{post.price}</span>{" "}
                  </h6>
                </div>
                <div className="flex-[1] flex justify-center items-center text-primary-100 text-3xl gap-4">
                  <IoChatboxEllipsesOutline />
                  <div className="" onClick={() => handleheart(index)}>
                    {fill[index] ? (
                      <IoHeart style={{ color: "#ed4956" }} />
                    ) : (
                      <IoHeartOutline />
                    )}
                  </div>
                  <FiPhoneCall />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
